export * from './category-list/category-list.component';
export * from './create-category/create-category.component';
export * from './document-list/document-list.component';
export * from './create-document/create-document.component';
export * from './assign-entity/assign-entity.component';
export * from './select-relation/select-relation.component';
export * from './docs-viewer/docs-viewer.component';
export * from './access-history-list/access-history-list.component';
export * from './sharing-doc-config/sharing-doc-config.component';
export * from './share-document/share-document.component';
